import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PhxCarouselComponent } from "./phx-carousel.component";
import { PhxCarouselItemDirective } from "./phx-carousel-item.directive";
import { PhxIconModule } from "../icon/icon.module";
import { PhxPaginationModule } from "../pagination/phx-pagination.module";
import { PhxIconButtonModule } from "../icon-button/phx-icon-button.module";

@NgModule({
  declarations: [
    PhxCarouselComponent,
    PhxCarouselItemDirective,
  ],
  imports: [
    CommonModule,
    PhxIconModule,
    PhxPaginationModule,
    PhxIconButtonModule
  ],
  exports: [
    PhxCarouselComponent,
    PhxCarouselItemDirective,
  ],
})
export class PhxCarouselModule { }